export default function ArticleFaqs({ faqs }) {
  if (!faqs?.length) return null;

  return (
    <div className="mt-10">
      <h2 className="text-2xl font-semibold tracking-tight text-gray-900 mb-4">
        FAQs
      </h2>
      <div className="flex flex-col divide-y divide-gray-100 border-t border-gray-100">
        {faqs.map((faq, i) => (
          <div key={`${faq.question}-${i}`} className="py-4">
            <p className="font-medium text-gray-900 mb-1">{faq.question}</p>
            <p className="text-[15px] leading-7 text-gray-600">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
